var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonthPicker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9318 10L13.5227 12.5909L10.9318 15.1818M7.04545 10L9.63636 12.5909L7.04545 15.1818M1 5.68182H10.5H20M2.72727 19.5H18.2727C18.7308 19.5 19.1702 19.318 19.4941 18.9941C19.818 18.6702 20 18.2308 20 17.7727V2.22727C20 1.76917 19.818 1.32983 19.4941 1.00591C19.1702 0.68198 18.7308 0.5 18.2727 0.5H2.72727C2.26917 0.5 1.82983 0.68198 1.50591 1.00591C1.18198 1.32983 1 1.76917 1 2.22727V17.7727C1 18.2308 1.18198 18.6702 1.50591 18.9941C1.82983 19.318 2.26917 19.5 2.72727 19.5Z",
    stroke: "#524F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthPicker);
export default __webpack_public_path__ + "static/media/month-picker.9d17f8d2624b23e47d3dad5d8d109a85.svg";
export { ForwardRef as ReactComponent };